<app-provider-details-layout>
  <ng-container *transloco="let t; read: 'providers.detailPage'">
    <!-- Stop health -->
    <div class="rounded-card bg-card p-6 shadow-hairline">
      <div class="mb-4 flex flex-wrap items-baseline justify-between gap-1">
        <span class="text-[11px] font-bold uppercase tracking-wide text-ink-3">{{ t('cards.stopHealth') }}</span>
        @if (!isDiagnosticsLoading() && (stopHealthTotals().newestAge || stopHealthTotals().oldestAge)) {
          <span class="text-[12px] text-ink-3">
            {{ t('stopHealth.subtitle', { newest: stopHealthTotals().newestAge, oldest: stopHealthTotals().oldestAge }) }}
          </span>
        }
      </div>
      @if (isDiagnosticsLoading()) {
        <span class="text-[13px] text-ink-3">—</span>
      } @else {
        @let totals = stopHealthTotals();
        <div class="flex flex-wrap items-baseline gap-x-10 gap-y-3">
          <div class="flex items-baseline gap-2">
            <span class="font-display text-[32px] font-semibold leading-9 text-ink-1">{{ totals.total }}</span>
            <span class="text-[13px] text-ink-3">{{ t('stopHealth.stopsReporting') }}</span>
          </div>
          <span class="flex items-center gap-1.5 text-[13px] text-ink-2">
            <span class="h-2 w-2 rounded-full bg-[var(--colorscales-green-500)]"></span>{{ t('stopHealth.ok') }}
            <span class="font-semibold text-ink-1">{{ totals.ok }}</span>
          </span>
          <span class="flex items-center gap-1.5 text-[13px] text-ink-2">
            <span class="h-2 w-2 rounded-full bg-[var(--colorscales-red-300)]"></span>{{ t('stopHealth.error') }}
            <span class="font-semibold text-ink-1">{{ totals.error }}</span>
          </span>
          <span class="flex items-center gap-1.5 text-[13px] text-ink-2">
            <span class="h-2 w-2 rounded-full bg-[var(--colorscales-orange-300)]"></span>{{ t('stopHealth.unknown') }}
            <span class="font-semibold text-ink-1">{{ totals.unknown }}</span>
          </span>
        </div>

        <app-stacked-bar class="mt-5 block" [segments]="stopSegments()" [legend]="false" />

        <p class="m-0 mt-4 border-t border-hairline pt-4 text-[12px] leading-[18px] text-ink-3">
          {{ t(totals.noSnapshotCount === 1 ? 'stopHealth.footnoteNoSnapshot' : 'stopHealth.footnoteNoSnapshotPlural', { count: totals.noSnapshotCount }) }}
        </p>
      }
    </div>
  </ng-container>
</app-provider-details-layout>
